var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.views
    ? _c(
        "ul",
        [
          _vm._l(_vm.views, function (view) {
            return _c(
              "li",
              { key: view.id, class: _vm.$style.flexParent },
              [
                _c("div", { class: _vm.$style.flex }, [
                  _c(
                    "div",
                    {
                      class: _vm.active(view.id)
                        ? _vm.$style.activeSubMenuItem
                        : _vm.$style.subMenuItem,
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.open(view)
                        },
                      },
                    },
                    [
                      _c("span", { class: _vm.$style.subMenuItemIcon }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("face"),
                        ]),
                      ]),
                      _c("span", { class: _vm.$style.subMenuItemText }, [
                        _vm._v(" " + _vm._s(view.name) + " "),
                        _c(
                          "div",
                          {
                            staticClass: "rbTooltip simple",
                            class: _vm.$style.tooltip,
                            attrs: { tooltip: "placement:top-start" },
                          },
                          [_vm._v(" " + _vm._s(view.name) + " ")]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      class: !_vm.active(view.id)
                        ? _vm.$style.manage
                        : _vm.$style.activeManage,
                      on: {
                        click: function ($event) {
                          return _vm.manage(view)
                        },
                      },
                    },
                    [_vm._v("settings")]
                  ),
                ]),
                _vm.active(view.id)
                  ? [
                      _c(
                        "div",
                        {
                          class: _vm.$style.flexChild,
                          on: { click: _vm.instantPreview },
                        },
                        [
                          _c("div", [_vm._v("Instant Preview")]),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("remove_red_eye"),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          class: _vm.$style.flexChild,
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.trigger(_vm.events.SEND_PREVIEW_EVENT)
                            },
                          },
                        },
                        [
                          _c("div", [_vm._v("Send Preview")]),
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              class: _vm.$style.flipHorizontal,
                            },
                            [_vm._v("reply")]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          class: _vm.$style.flexChild,
                          on: {
                            click: function ($event) {
                              return _vm.trigger(_vm.events.MANAGE_VIEW_LINK)
                            },
                          },
                        },
                        [
                          _c("div", [_vm._v("Directory Link")]),
                          _c("i", { staticClass: "material-icons icon" }, [
                            _vm._v("link"),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          class: _vm.$style.flexChild,
                          on: {
                            click: function ($event) {
                              return _vm.trigger(_vm.events.EDIT_VIEW_EVENT)
                            },
                          },
                        },
                        [
                          _c("div", [_vm._v("Display Settings")]),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("tune"),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          class: _vm.$style.flexChild,
                          on: {
                            click: function ($event) {
                              return _vm.trigger(_vm.events.EDIT_HEADER_EVENT)
                            },
                          },
                        },
                        [
                          _c("div", [_vm._v("Edit Header")]),
                          _c("i", { staticClass: "material-icons icon" }, [
                            _vm._v("edit"),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        { class: _vm.$style.flexChild },
                        [
                          _c("check-box", {
                            attrs: {
                              value: view.showSubHeader,
                              "check-box-value": true,
                              "check-box-label": "Sub Header",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.trigger(
                                  _vm.events.SHOW_SUBHEADER_EVENT
                                )
                              },
                            },
                          }),
                          view.showSubHeader
                            ? _c(
                                "i",
                                {
                                  staticClass: "material-icons icon",
                                  on: {
                                    click: function ($event) {
                                      return _vm.trigger(
                                        _vm.events.EDIT_SUBHEADER_EVENT
                                      )
                                    },
                                  },
                                },
                                [_vm._v("edit")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { class: _vm.$style.flexChild },
                        [
                          _c("check-box", {
                            attrs: {
                              value: view.showWarning,
                              "check-box-value": true,
                              "check-box-label": "Warning",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.trigger(
                                  _vm.events.SHOW_WARNING_EVENT
                                )
                              },
                            },
                          }),
                          view.showWarning
                            ? _c(
                                "i",
                                {
                                  staticClass: "material-icons icon",
                                  on: {
                                    click: function ($event) {
                                      return _vm.trigger(
                                        _vm.events.EDIT_WARNING_EVENT
                                      )
                                    },
                                  },
                                },
                                [_vm._v("edit")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          class: _vm.$style.flexChild,
                          on: {
                            click: function ($event) {
                              return _vm.trigger(
                                _vm.events.EDIT_BACKGROUND_EVENT
                              )
                            },
                          },
                        },
                        [
                          _c("div", [_vm._v("Edit Background")]),
                          _c("i", { staticClass: "material-icons icon" }, [
                            _vm._v("image"),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          class: _vm.$style.flexChild,
                          on: { click: _vm.exportToExcel },
                        },
                        [
                          _c("div", [_vm._v("Export to Excel")]),
                          _c(
                            "i",
                            {
                              staticClass: "material-icons icon",
                              class: _vm.$style.flipVertical,
                            },
                            [_vm._v("publish")]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          class: _vm.$style.flexChild,
                          on: {
                            click: function ($event) {
                              return _vm.trigger(_vm.events.SELECT_HOTELS)
                            },
                          },
                        },
                        [
                          _c("div", [_vm._v("Select Hotels")]),
                          _c("i", { staticClass: "material-icons icon" }, [
                            _vm._v("check_box"),
                          ]),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            )
          }),
          _c(
            "li",
            {
              class: _vm.$style.subMenuItem,
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.createNew.apply(null, arguments)
                },
              },
            },
            [
              _c("span", { class: _vm.$style.subMenuItemIcon }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("add_circle_outline"),
                ]),
              ]),
              _c("span", { class: _vm.$style.subMenuItemText }, [
                _vm._v("Create New View"),
              ]),
            ]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }